import { useChat } from 'react-live-chat-loader'

interface ICustomIntercomBtnProps {
    html: string;
    classes?: string;
}

const CustomIntercomBtn = ({ html, classes }: ICustomIntercomBtnProps) => {
    // eslint-disable-next-line
    const [_state, loadChat] = useChat();

    const onClick = () => {
        loadChat({ open: true });
    };

    return (
        <button
            className={ classes ?? '' }
            type="button"
            onClick={ onClick }
            dangerouslySetInnerHTML={{ __html: html }}
        />
    )
};

export default CustomIntercomBtn;